/* eslint-disable import/prefer-default-export */
import _ from 'lodash';

import { messenger as messengerRedux } from '@breezeway/brzw-react-core';

import common from '@common';
import * as messengerActions from './actions';

const {
  utils: {
    messenger: {
      constants: { MESSENGER_NEW_MESSAGE_ITEM_KEY, CONVERSATIONS_DEFAULT_LIMIT },
      helpers: { updateMessengerRoute },
    },
  },
} = common;

/**
 * @param {Object} options
 */
export const fetchConversations = (options = {}) => dispatch => {
  dispatch(messengerActions.setConversationsFetchingFlag(true));

  dispatch(
    messengerRedux.actions.getConversations(
      options,
      conversations => {
        const hasNextPage =
          _.get(options, 'limit', CONVERSATIONS_DEFAULT_LIMIT) === _.size(conversations);
        dispatch(messengerActions.setHasNextPageFlag(hasNextPage));
        dispatch(messengerActions.setConversationsFetchingFlag(false));
      },
      dispatch.bind(this, messengerActions.setConversationsFetchingFlag(false)),
    ),
  );
};

/**
 * @param {Object} options
 */
export const fetchMoreConversations = (options = {}) => dispatch => {
  dispatch(
    messengerRedux.actions.getMoreConversations(options, conversations => {
      const hasNextPage =
        _.get(options, 'limit', CONVERSATIONS_DEFAULT_LIMIT) === _.size(conversations);
      dispatch(messengerActions.setHasNextPageFlag(hasNextPage));
    }),
  );
};

/**
 * @param {Number} conversationId
 */
export const fetchConversationMessages = conversationId => dispatch => {
  if (conversationId !== MESSENGER_NEW_MESSAGE_ITEM_KEY) {
    dispatch(messengerActions.setConversationFetchingFlag(true));
    dispatch(messengerRedux.actions.getConversationPeople(conversationId));
    dispatch(messengerRedux.actions.getConversation(conversationId));
    dispatch(
      messengerRedux.actions.getConversationMessages(
        conversationId,
        () => {
          dispatch(messengerRedux.actions.getUnreadCount());
          dispatch(messengerActions.setConversationFetchingFlag(false));
        },
        dispatch.bind(this, messengerActions.setConversationFetchingFlag(false)),
      ),
    );
  }
};

/**
 * @param {Number} conversationId
 * @param {String} message
 * @param {Array} files
 */
export const sendMessage = (conversationId, message, files) => dispatch => {
  dispatch(messengerActions.setSendingMessageFlag(true));

  dispatch(
    messengerRedux.actions.sendMessage(
      conversationId,
      message,
      files,
      dispatch.bind(this, messengerActions.setSendingMessageFlag(false)),
      dispatch.bind(this, messengerActions.setSendingMessageFlag(false)),
    ),
  );
};

/**
 * @param {Object} message
 * @param {Array} files
 */
export const sendNewMessage = (message, files) => dispatch => {
  dispatch(messengerActions.setSendingNewMessageFlag(true));

  dispatch(
    messengerRedux.actions.sendNewMessage(
      message,
      files,
      response => {
        const messageObject = _.last(response);
        const { id: threadId } = messageObject;

        dispatch(messengerActions.setSendingMessageFlag(false));
        dispatch(messengerActions.toggleNewMessageItem(false));
        dispatch(messengerActions.selectConversationActiveItem(threadId));
        updateMessengerRoute(threadId);
      },
      dispatch.bind(this, messengerActions.setSendingNewMessageFlag(false)),
    ),
  );
};

/**
 * @param {Number} conversationId
 * @param {String} status
 */
export const setConversationStatus = (conversationId, status) => dispatch => {
  dispatch(messengerActions.setConversationsFetchingFlag(true));

  dispatch(
    messengerRedux.actions.setConversationStatus(
      conversationId,
      { type_conversation_status: status },
      () => {
        dispatch(messengerActions.setConversationsFetchingFlag(false));
        dispatch(messengerActions.clearActiveItem());
        updateMessengerRoute('');
      },
      dispatch.bind(this, messengerActions.setConversationsFetchingFlag(false)),
    ),
  );
};
